/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CabinTypeResponse
 */
export interface CabinTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof CabinTypeResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CabinTypeResponse
     */
    name?: string | null;
}

export function CabinTypeResponseFromJSON(json: any): CabinTypeResponse {
    return CabinTypeResponseFromJSONTyped(json, false);
}

export function CabinTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CabinTypeResponseToJSON(value?: CabinTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}


